import { Chain } from 'src/types/enums';
import { callContractTransaction, callContractView } from './common';

export const setAddr = async (
  domain: Array<string>,
  address: string,
  chain: Chain,
  resolverAddress: string,
) => {
  if (chain === Chain.C) {
    await callContractTransaction(
      'Resolver',
      'setAddr(string[],address)',
      [domain, address],
      resolverAddress,
    );
  } else {
    await callContractTransaction(
      'Resolver',
      'setAddr(string[],string,uint8)',
      [domain, address, chain],
      resolverAddress,
    );
  }
};

export const getAddress = async (
  domain: Array<string>,
  resolverAddress: string,
  chain: Chain,
): Promise<string> => {
  if (chain === Chain.C) {
    const address = await callContractView(
      'Resolver',
      'getAddr(string[])',
      [domain],
      resolverAddress,
    );
    return address === '0x0000000000000000000000000000000000000000'
      ? ''
      : address;
  } else {
    const address = await callContractView(
      'Resolver',
      'getAddr(string[],uint8)',
      [domain, chain],
      resolverAddress,
    );
    return address === '0x' ? '' : address;
  }
};

export const getPubKey = async (
  domain: Array<string>,
  resolverAddress: string,
): Promise<string> => {
  const pubKey = await callContractView(
    'Resolver',
    'getPubKey',
    [domain],
    resolverAddress,
  );
  return pubKey;
};

export const setPubKey = async (
  domain: Array<string>,
  pubKey: string,
  resolverAddress: string,
) => {
  await callContractTransaction(
    'Resolver',
    'setPubKey',
    [domain, pubKey],
    resolverAddress,
  );
};

export const getContentHash = async (
  domain: Array<string>,
  resolverAddress: string,
): Promise<string> => {
  const contentHash = await callContractView(
    'Resolver',
    'getContentHash',
    [domain],
    resolverAddress,
  );
  return contentHash === '0x' ? '' : contentHash;
};

export const setContentHash = async (
  domain: Array<string>,
  data: string,
  resolverAddress: string,
) => {
  await callContractTransaction(
    'Resolver',
    'setContentHash',
    [domain, data],
    resolverAddress,
  );
};

export const approve = async (
  domain: Array<string>,
  manager: string,
  approved: boolean,
  resolverAddress: string,
) => {
  await callContractTransaction(
    'Resolver',
    'approve',
    [domain, manager, approved],
    resolverAddress,
  );
};
